// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1upTW","name":"Header_name__hpbnG","birthday":"Header_birthday__3v2ct","skeleton":"Header_skeleton__1tcZ4"};